import React from 'react';
import './FooterMenu.scss';

import {
  PhoneIcon,
  EmailIcon,
  AddressIcon,
  CalendarIcon,
} from '../../../assets/img/svgs';

import GooglePartner from '../../../assets/img/top-google.svg';
import DigitalNetworkAgency from '../../../assets/img/digital-network-agency.svg';
import Awwwards from '../../../assets/img/top-awwwards.svg';
import Csswinner from '../../../assets/img/top-csswinner.svg';
import Clutch from '../../../assets/img/top-clutch.svg';
import CssDesignAwards from '../../../assets/img/css-design-awards.svg';

import { footer } from '../../../editable-stuff/config';

export default function FooterMenu() {
  return (
    <section id='footer-menus' className='p-100'>
      <div className='container'>
        <div className='row'>
          <div className='col-12 col-sm-6 col-lg-3'>
            <h4>Get In Touch</h4>
            <ul className='menu'>
              <li>
                <a href='tel:+442078705794'>
                  <PhoneIcon />
                  (+44) 0207 870 5794
                </a>
              </li>
              <li>
                <a href='tel:+12123727640'>
                  <PhoneIcon />
                  +1 (212) 372 7640
                </a>
              </li>
              <li>
                <a href={`mailto:${footer.email}`}>
                  <EmailIcon /> {footer.email}
                </a>
              </li>
              <li>
                <a
                  href={footer.address1.link}
                  target='_blank'
                  rel='noreferrer noopener'
                >
                  <AddressIcon /> {footer.address1.title}
                </a>
              </li>
              <li>
                <a
                  href={footer.address2.link}
                  target='_blank'
                  rel='noreferrer noopener'
                >
                  <AddressIcon /> {footer.address2.title}
                </a>
              </li>
              <li>
                <CalendarIcon /> {footer.timings}
              </li>
            </ul>
          </div>
          <div className='col-12 col-sm-6 col-lg-3'>
            <h4>Accreditation</h4>
            <ul className='row accred'>
              <li>
                <a
                  style={{ maxWidth: '120px' }}
                  href='#'
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                >
                  <img
                    loading='lazy'
                    src={GooglePartner}
                    alt='google partner'
                    width='93'
                    height='41'
                  />
                </a>
              </li>
              <li>
                <a href='#' target='_blank' rel='noopener noreferrer nofollow'>
                  <img
                    loading='lazy'
                    src={DigitalNetworkAgency}
                    alt='digital agency logo'
                    width='140'
                    height='47'
                  />
                </a>
              </li>
              <li>
                <a
                  style={{ maxWidth: '140px' }}
                  href='#'
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                >
                  <img
                    loading='lazy'
                    src={Awwwards}
                    alt='awwwards-logo'
                    width='111'
                    height='18'
                  />
                </a>
              </li>
              <li>
                <a
                  style={{ maxWidth: '150px' }}
                  href='#'
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                >
                  <img
                    loading='lazy'
                    src={Csswinner}
                    alt='css winners'
                    width='120'
                    height='15'
                  />
                </a>
              </li>
              <li>
                <a
                  style={{ maxWidth: '100px' }}
                  href='#'
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                >
                  <img
                    loading='lazy'
                    src={Clutch}
                    alt='clutch logo'
                    width='75'
                    height='21'
                  />
                </a>
              </li>
              <li>
                <a
                  style={{ maxWidth: '160px' }}
                  href='#'
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                >
                  <img
                    loading='lazy'
                    src={CssDesignAwards}
                    alt='css design awards logo'
                    width='129'
                    height='20'
                  />
                </a>
              </li>
            </ul>
            <div id='wcb' className='carbonbadge'>
              <div id='wcb_p'>
                <span id='wcb_g'>
                  0.18g of CO<sub>2</sub>/view
                </span>
                <a
                  id='wcb_a'
                  target='_blank'
                  rel='noopener'
                  href='https://websitecarbon.com'
                >
                  Website Carbon
                </a>
              </div>
              <span id='wcb_2'>&nbsp;Cleaner than 82% of pages tested</span>
            </div>
          </div>
          <div className='col-12 col-sm-6 col-lg-3'>
            <h4>Quick Links</h4>
            <ul className='menu row'>
              <li>
                <a href='#'>Project Planner</a>
              </li>
              <li>
                <a href='#'>Website Design</a>
              </li>
              <li>
                <a href='#'>About CBD</a>
              </li>
              <li>
                <a href='#'>SEO Services</a>
              </li>
              <li>
                <a href='#'>SEO Checker</a>
              </li>
              <li>
                <a href='#'>Hosting</a>
              </li>
              <li>
                <a href='#'>Graphic Design</a>
              </li>
              <li>
                <a href='#'>E-Commerce</a>
              </li>
            </ul>
          </div>
          <div className='col-12 col-sm-6 col-lg-3'>
            <h4>From The Blog</h4>
            <ul className='recent-blog'>
              <li>
                <a href='#'>
                  <img
                    loading='lazy'
                    src={require('../../../assets/img/Blogs/blog-post-1.jpg')}
                    alt='blog post thumbnail'
                  />
                  <div className='content'>
                    <p>Website Launch - Gibraltar Nature Reserve</p>
                    <span>February 20, 2023</span>
                  </div>
                </a>
              </li>
              <li>
                <a href='#'>
                  <img
                    loading='lazy'
                    src={require('../../../assets/img/Blogs/blog-post-2.jpg')}
                    alt='blog post thumbnail'
                  />
                  <div className='content'>
                    <p>The Purpose of Mental Models in Web Design</p>
                    <span>June 8, 2022</span>
                  </div>
                </a>
              </li>
              <li>
                <a href='#'>
                  <img
                    loading='lazy'
                    src={require('../../../assets/img/Blogs/blog-post-3.jpg')}
                    alt='blog post thumbnail'
                  />
                  <div className='content'>
                    <p>Sustainable Website Design Tips</p>
                    <span>March 31, 2022</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
